import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import Switch from "@mui/material/Switch";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
export default (function (props) {
  var customProps = props.customProps,
    value = props.value,
    setValue = props.setValue,
    labelYes = props.labelYes,
    labelNo = props.labelNo,
    readonly = props.readonly,
    config = props.config;
  var renderSize = config.settings.renderSize;
  var onChange = function onChange() {
    setValue(!value);
  };
  return /*#__PURE__*/React.createElement(FormControl, {
    size: renderSize
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "div"
  }, /*#__PURE__*/React.createElement(Grid, {
    component: "label",
    container: true,
    alignItems: "center",
    spacing: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    component: "span"
  }, labelNo), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    component: "span"
  }, /*#__PURE__*/React.createElement(Switch, _extends({
    checked: !!value,
    onChange: onChange,
    disabled: readonly,
    size: renderSize
  }, customProps))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    component: "span"
  }, labelYes))));
});